import { AppRoute, MenuActionId } from '@common/enums'

const PROJECT_ACTION_ROUTES: Partial<Record<MenuActionId, AppRoute>> = {
  [MenuActionId.PROJECT_SETTINGS]: AppRoute.SETTINGS_PROJECT,
  [MenuActionId.PROJECT_MEMBERS]: AppRoute.SETTINGS_PROJECT_MEMBERS,
  [MenuActionId.INVITE_PEOPLE]: AppRoute.SETTINGS_PROJECT_MEMBERS,
}

export function getRouteForProjectAction(actionId: string): AppRoute | null {
  return PROJECT_ACTION_ROUTES[actionId as MenuActionId] ?? null
}
